import axios from "axios";
import { useEffect, useState } from "react";
import localize from "../../../../common/localize";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import DynamicFormPageForReport from "./DynamicFormPageForReport";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";

export default function DynamicFormHeaderForReport({
  requiredForm,
  dynamicForm,
  statusChangeId,
  eventId,
  original,
  hideSignatures,
  formResultsFormat,
  hideModificationDate,
}) {
  const { DYNAMIC_FORM_ENDPOINT, config } = useGlobalContext();
  const [dynamicFormPages, setDynamicFormPages] = useState(null);

  const getDynamicFormPages = async () => {
    const pages = await axios.get(
      `${DYNAMIC_FORM_ENDPOINT}/${dynamicForm?.Id}/page`,
      config,
    );

    setDynamicFormPages(pages?.data?.Data);
  };

  useEffect(() => {
    if (config) {
      getDynamicFormPages();
    }
  }, [config]);

  return (
    <div
      className="report_section_without_top_border"
      style={{ padding: "5px", border: "1px solid black" }}
    >
      {requiredForm && (
        <ReportSectionTitle
          title={`${localize.required_form}: ${dynamicForm?.Name}`}
          allBorders
        />
      )}

      {dynamicForm?.Description && (
        <div className="w-full m-2">
          <label className="report_little_text">
            <b>{localize.description}: </b>
            {dynamicForm.Description}
          </label>
        </div>
      )}

      {dynamicFormPages?.length > 0 ? (
        dynamicFormPages.map((page) => (
          <div key={page.Id}>
            <div className="page-break" />
            <div style={{ marginTop: "4px" }}>
              <ReportSectionTitle title={page.Name} />
              <div className="report_section_without_top_border">
                <DynamicFormPageForReport
                  page={page}
                  statusChangeId={statusChangeId}
                  eventId={eventId}
                  originalFieldValue={original}
                  hideSignatures={hideSignatures}
                  format={formResultsFormat}
                  hideModificationDate={hideModificationDate}
                />
              </div>
            </div>
          </div>
        ))
      ) : (
        <label className="report_little_text">{localize.no_pages_added}</label>
      )}
    </div>
  );
}
